export const getFromLS = (name) => {
    const item = JSON.parse(localStorage.getItem(name));

    return item ? item : [];
}
